module.exports = __webpack_public_path__ + "b00583f6d4cd349ce947f7124b87e4b7.png";